import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { LoketLeaveBalances } from '@/containers'
import { getEmployeeLoketBalances } from '@/redux/absences/absencesLegacyActions'
import { Reducers } from '@/redux/reducers'
import { useTypedDispatch as useLegacyTypedDispatch } from '@/redux/store'
import { getProfileOfCurrentUser } from '@/redux/user/userActions'


export const ConnectedLoketLeaveBalances: FC = () => {
    const dispatch = useLegacyTypedDispatch()

    const { currentUser } = useSelector((state: Reducers) => state.userReducer)
    const { loading, employeeLoketLeaveBalance } = useSelector((state: Reducers) => state.absencesReducer)
    const [loketEmployeeNotFound, setLoketEmployeeNotFound] = useState(false)

    useEffect(() => {
        if (! currentUser) {
            dispatch(getProfileOfCurrentUser())
        }
    }, [])

    useEffect(() => {
        if (! currentUser) {
            return
        }

        if (! currentUser.loketEmployeeId) {
            setLoketEmployeeNotFound(true)
        } else {
            dispatch(getEmployeeLoketBalances(currentUser.loketEmployeeId))
        }
    }, [currentUser])

    return (
        <LoketLeaveBalances
            loading={loading}
            loketLeaveBalance={employeeLoketLeaveBalance || null}
            loketEmployeeNotFound={loketEmployeeNotFound}
        />
    )
}
